import { Check, X } from "lucide-react";
import { useTranslation } from "react-i18next";

interface PasswordChecklistProps {
  password: string;
}

const REQUIREMENTS = [
  { key: "minLength", test: (p: string) => p.length >= 8 },
  { key: "uppercase", test: (p: string) => /[A-Z]/.test(p) },
  { key: "lowercase", test: (p: string) => /[a-z]/.test(p) },
  { key: "number", test: (p: string) => /[0-9]/.test(p) },
] as const;

export default function PasswordChecklist({ password }: PasswordChecklistProps) {
  const { t } = useTranslation("common");
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "6px", width: "100%", textAlign: "left" }}>
      {REQUIREMENTS.map((req) => {
        const met = req.test(password);
        return (
          <div key={req.key} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {met ? (
              <Check size={14} color="#10b981" strokeWidth={3} />
            ) : (
              <X size={14} color="#d1d5db" strokeWidth={2} />
            )}
            <span style={{ fontSize: "12px", color: "#9ca3af" }}>{t(`passwordRequirements.${req.key}`)}</span>
          </div>
        );
      })}
    </div>
  );
}
